module.exports = __webpack_public_path__ + "img/region.d46e61b.svg";